<template>
  <div class="content-wrapper">
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <h1>
        App Name - {{sheetTitle}}        
      </h1>
      <ol class="breadcrumb">
        <li><a href="/messages-dashboard"><i class="fa fa-dashboard"></i> Home</a></li>
        <li class="active">App Messages Rows</li>
      </ol>
    </section>
    
    <!-- Main content -->
    <section class="content">
      <div class="row">
        <div class="col-xs-12 col-md-12 col-lg-12">
          <div class="box box-default">            
            <div class="box-body">
              <div class="col-xs-12 col-lg-12">  
                <div class="appsDiv">
                  <all-rows ref="allRowChild" :allRowsObj.sync="allRows" v-on:add-message="openAddMessagePopup($event)" v-on:delete-message="openDeleteMessagePopup($event)" v-on:refresh-message="refreshMessage"/>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /.row -->
    </section>
    <BlockUI v-if="loading"><i class="fa fa-cog fa-spin fa-3x fa-fw"></i><br/>Please wait...</BlockUI>
    <add-application-message 
      v-if="isMessageModalVisible"               
      :popupTitle="popupTitle"        
      :gRowObj="messagePopupData.gRowObj"
      :primaryLangText="messagePopupData.primaryLangText"
      :secondaryLangText="messagePopupData.secondaryLangText"
      :allRows="messagePopupData.allRows"
      @closeModal = "closeMessagePopup()"
      @closeLoader = "closeLoader($event)"
      @onSubmit = "submitMessagePopup($event)"/>

      <delete-application-message 
      v-if="isDeleteMessageModalVisible"        
      :confirmationMessage="confirmationMessage" 
      :actionToBePerformed="actionToBePerformed"
      @close = "closeDeleteMessagePopup()"
      @deleteMessage = "confirmDeleteMessage()"/>
    <!-- /.content -->
  </div>
</template>

<script>
  import api from '../../../utils/api'
  import addMessageModal from './../popup/addApplicationMessage'
  import deleteMessageModal from './../popup/deleteConfirmation'
  import allRowsView from './allRows'
  export default {
    components: {
      'all-rows': allRowsView,
      'add-application-message': addMessageModal,
      'delete-application-message': deleteMessageModal
    },
    methods: {
      refreshMessage () {
        console.log('-----call refresh message')
        this.getDataFromMongo(this.$route.query.sheetTitle, this.$route.query.sheetReference)
      },
      getLanguageData () {
        let languageList = []
        return new Promise(resolve => {
          api.buildRequest('languages', 'GET').then(({ data }) => {
            this.countryLanguageList = data.payload
            for (var country in data.payload) {
              data.payload[country].forEach(function (item) {
                languageList.push(
                  {
                    langShortcode: item.alias,
                    langName: item.name
                  }
                )
              })
            }
            languageList = [...new Map(languageList.map(item => [item['langShortcode'], item])).values()]
            this.languageList = languageList
            console.log('languageList', this.languageList)
            resolve()
          })
        })
      },
      prepareConfigData () {
        this.configNewList = []
        var configData = this.allRows[0].config
        var newRecord = {}
        if (this.allRows[0].messageType === 'countrywise') {
          console.log('==Inside App_Launch')
          for (var configObj in configData) {
            var finalData = {
              name: configObj,
              title: configObj,
              displayText: configData[configObj].displayText,
              isCustomMessage: configData[configObj].isCustomMessage || false,
              country: []
            }
            for (var country in this.countryLanguageList) {
              var countryData = {
                languages: [],
                country: country
              }
              const languageData = this.countryLanguageList[country]
              for (var language of languageData) {
                const countryObj = {
                  langName: language.name,
                  langCode: language.alias,
                  message: ''
                }
                if (configData && configData[configObj] && configData[configObj][country] && configData[configObj][country][language.alias]) {
                  countryObj.message = configData[configObj][country][language.alias]
                }
                countryData.languages.push(countryObj)
              }
              finalData.country.push(countryData)
            }
            this.configNewList.push(finalData)
          }
          newRecord = {
            name: '',
            title: '',
            country: []
          }
          for (var countryNew in this.countryLanguageList) {
            var countryDataNew = {
              languages: [],
              country: countryNew
            }
            const languageData = this.countryLanguageList[countryNew]
            for (var languageObj of languageData) {
              const countryObj = {
                langName: languageObj.name,
                langCode: languageObj.alias,
                message: ''
              }
              countryDataNew.languages.push(countryObj)
            }
            newRecord.country.push(countryDataNew)
          }
        } else {
          for (var config in configData) {
            this.languageList.forEach(function (item) {
              if (!configData[item.langShortcode]) {
                configData[item.langShortcode] = {}
                messageData = configData[config]
                for (var message in messageData) {
                  configData[item.langShortcode][message] = ''
                }
              }
            })
          }
          for (config in configData) {
            var messageData = configData[config]
            for (var message in messageData) {
              let obj = this.configNewList.find(x => x.name === message)
              let dataObj = {}
              if (!obj) {
                dataObj.name = message
                dataObj.title = message
                dataObj.language = []
                let objLang = this.languageList.find(x => x.langShortcode === config)
                if (objLang) {
                  dataObj.language.push({
                    langName: objLang.langName,
                    langShortcode: config,
                    message: messageData[message]
                  })
                  this.configNewList.push(dataObj)
                }
              } else {
                let objLang = this.languageList.find(x => x.langShortcode === config)
                if (objLang) {
                  obj.language.push({
                    langName: objLang.langName,
                    langShortcode: config,
                    message: messageData[message]
                  })
                }
              }
            }
          }
          newRecord = {
            name: '',
            title: '',
            language: []
          }
          this.languageList.forEach(function (x) {
            x.message = ''
            newRecord.language.push(x)
          })
        }
        console.log('configNewList', this.configNewList)
        this.allRows[0].configNew = this.configNewList

        this.allRows[0].newRecord = newRecord
        this.allRows[0].languageList = this.languageList
      },
      getDataFromMongo (sheetTitle, sheetReference) {
        console.log('inside getDataFromMongo my function')
        this.loading = true
        // this.config['stages'] = this.stages
        api.buildRequest('getAppMessagesFromMongo', 'POST', {sheetTitle: sheetTitle, sheetReference: 'messagesForApps'})
            .then(response => {
              this.loading = false
              if (response.status === 200) {
                this.allRows = response.data.payload.keywords
                this.prepareConfigData()
                console.log('response data', response.data)
              } else {
                console.log('something went wrong')
              }
            }).catch(({ response }) => {
              this.loading = false
              this.$swal({
                type: 'error',
                text: response ? response.data.payload.message : 'An error occurred'
              })
            })
      },
      openAddMessagePopup (messagePopupData) {
        console.log(`messagePopupData=${JSON.stringify(messagePopupData)}`)
        if (messagePopupData.hasOwnProperty('gRowObj')) {
          if (messagePopupData.gRowObj.hasOwnProperty('message')) {
            if (messagePopupData.gRowObj.message !== undefined && messagePopupData.gRowObj.message !== '') {
              this.popupTitle = 'Update Message'
              this.returnMessage = ' Messages Updated successfully !'
            } else {
              this.popupTitle = 'Add Message'
              this.returnMessage = 'Messages Added successfully !'
            }
          } else {
            this.popupTitle = 'Add Message'
          }
        }
        this.isMessageModalVisible = true
        // this.loading = true
        this.messagePopupData = messagePopupData
      },
      openDeleteMessagePopup (messagePopupData) {
        this.isDeleteMessageModalVisible = true
        this.messageDeletePopupData = messagePopupData
        console.log('del rec', this.messageDeletePopupData)
      },
      closeMessagePopup () {
        console.log('close call')
        this.isMessageModalVisible = false
        this.loading = false
      },
      submitMessagePopup (allRows) {
        console.log('submit call', allRows)
        this.isMessageModalVisible = false
        this.loading = false
        this.$swal({
          type: 'success',
          text: this.returnMessage
        })
        // this.$refs.allRowChild.$set(allRows, allRows)
        // allRowsView.props.allRowsObj = allRows
        this.refreshMessage()
      },
      closeLoader (event) {
        console.log('call close loader', event)
        this.loading = true
      },
      closeDeleteMessagePopup () {
        console.log('close delete loader----------')
        this.isDeleteMessageModalVisible = false
        this.loading = false
      },
      confirmDeleteMessage () {
        console.log('delete CONFIRMATION', this.messageDeletePopupData)
        this.isDeleteMessageModalVisible = false
        this.$refs.allRowChild.deleteMsg(this.messageDeletePopupData)
        // this.refreshMessage()
        // this.loading = true
        // allRowsView.props.allRowsObj = allRows
      }
    },
    computed: {
      isStages () {
        return Object.keys(this.allRows).length
      }
    },
    data () {
      return {
        countryLanguageList: {},
        languageList: [],
        configNewList: [],
        returnMessage: '',
        allRows: {},
        sheetTitle: '',
        Data: {},
        loading: false,
        popupTitle: 'Add Message',
        isMessageModalVisible: false,
        isDeleteMessageModalVisible: false,
        messagePopupData: {},
        messageDeletePopupData: {},
        actionToBePerformed: 'Delete Message',
        confirmationMessage: 'Are you sure you want to delete this Message?'
      }
    },
    async mounted () {
      // retrieve the configuration from mongodb
      await this.getLanguageData()
      if (this.$route.query.sheetTitle) {
        this.sheetTitle = this.$route.query.sheetTitle
        this.getDataFromMongo(this.$route.query.sheetTitle, this.$route.query.sheetReference)
        // this.getAllmessageFromMongo(this.$route.query.sheetTitle, this.$route.query.sheetReference)
      } else {
      }
    }
  }
</script>

<style>
  .value {
    font-weight: bold;
  }
  .box-body {
    min-height: calc(100vh - 171px);
  }
  .form-loader img {
    width: 30px;
    height: 30px;
  }
  .action-button {
    clear: both;
    display: flex;
    justify-content: center;
  }
  .appsDiv {
    width: 100%;
    height: 100%;
    left: 50%;
    -webkit-transform: none;
  }
</style>



// WEBPACK FOOTER //
// appmessageupdate.vue?78772ac7